import { useRouter } from 'next/router';

import { CHANNEL } from '@boss/constants/corporate-jobs';
import { Tracker } from '@boss/utils';

export const useEventTracker = () => {
  const { locale } = useRouter();

  const commonFields = {
    language: locale,
    brand: CHANNEL ?? '',
  };

  const tracker = new Tracker(commonFields);

  const trackPageView = (pageType: string) =>
    tracker.trackPageView({
      pageType,
    });

  const trackLinkClick = (props: Record<string, unknown>) =>
    tracker.trackLinkClick({
      ...props,
    });

  const trackCustomEvent = (event: string, props: Record<string, unknown>) =>
    tracker.trackCustomEvent({
      event,
      ...props,
    });

  return {
    trackPageView,
    trackLinkClick,
    trackCustomEvent,
  };
};
